import type { ScreenerData } from "epsm-api-types/models";
import {
	formatValueNumber,
	formatValuePercent,
} from "@/components/widgets/helpers/FormattingHelpers";
import { MIN_MAX_COLUMN_CLASSES } from "@/components/widgets/Revision/config";
import { useHandleTickerClick } from "@/components/widgets/Revision/ui/components/CompetitorsGrid/lib/hooks";
import { cn } from "@/lib/utils";
import { KEY } from "@/shared/constants/keyboard";
import { componentClassNames } from "../../../config";
import { LineHeader } from "../LineHeader";

export const Competitors = ({
	topCompetitorsScreenerData,
	tileId,
}: {
	topCompetitorsScreenerData: ScreenerData[] | null;
	tileId: string;
}) => {
	const handleTickerClick = useHandleTickerClick(tileId);

	if (
		!topCompetitorsScreenerData?.length ||
		topCompetitorsScreenerData?.length === 1
	)
		return null;

	return (
		<div className={componentClassNames} data-testid="competitors-table">
			<LineHeader title="Peer Multiples" />

			<table className="w-full text-right border-none">
				<thead>
					<tr className="border-none">
						<th className={MIN_MAX_COLUMN_CLASSES} />
						<th
							className={cn("text-center font-normal", MIN_MAX_COLUMN_CLASSES)}
						>
							PE TTM
						</th>
						<th
							className={cn("text-center font-normal", MIN_MAX_COLUMN_CLASSES)}
						>
							PE Fwd 1Y
						</th>
						<th
							className={cn("text-center font-normal", MIN_MAX_COLUMN_CLASSES)}
						>
							LTG
						</th>
						<th
							className={cn("text-center font-normal", MIN_MAX_COLUMN_CLASSES)}
						>
							PEG TTM
						</th>
					</tr>
				</thead>
				<tbody>
					{topCompetitorsScreenerData?.map((competitor) => {
						if (!competitor?.ticker) return null;

						return (
							<tr key={competitor.ticker}>
								<td
									className="text-left cursor-pointer"
									data-row-id={competitor.ticker}
									onClick={handleTickerClick}
									onKeyDown={(event) => {
										if (event.key === KEY.ENTER || event.key === KEY.SPACE) {
											handleTickerClick(event);
										}
									}}
								>
									{competitor.ticker}
								</td>
								<td>{formatValueNumber(competitor?.pe_ttm_ratio)}</td>
								<td>{formatValueNumber(competitor?.pe_fy_ratio)}</td>
								<td>{formatValuePercent(competitor?.ltg_est?.mean)}</td>
								<td>{formatValueNumber(competitor?.peg_ttm)}</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
};
